module.exports = __webpack_public_path__ + "static/img/management.80e8176a.png";